<template>
  <rest-form-page
    :page-title="pageTitle"
    :fetch-endpoint="fetchEndpoint"
    :save-endpoint="saveEndpoint"
    :model="model"
    :readonly="readonly"
  >
    <template slot="form" v-if="model">
      <form-section
        :title="$t('DataRetention_Users_Title')"
        :description="$t('DataRetention_Users_Description')"
      >
        <el-row>
          <el-col :span="8">
            <rest-form-item
              prop="uncontactable_web_devices_retention_period"
              :label="
                $t('DataRetention_Field_UncontactableWebDevicesRetentionPeriod')
              "
              :hint="
                $t(
                  'DataRetention_Field_UncontactableWebDevicesRetentionPeriod_Hint'
                )
              "
            >
              <el-input
                v-model="model.uncontactable_web_devices_retention_period"
                placeholder="None"
              />
            </rest-form-item>
          </el-col>

          <el-col :span="8">
            <rest-form-item
              prop="uncontactable_anonymous_profiles_retention_period"
              :label="
                $t(
                  'DataRetention_Field_UncontactableAnonymousProfilesRetentionPeriod'
                )
              "
              :hint="
                $t(
                  'DataRetention_Field_UncontactableAnonymousProfilesRetentionPeriod_Hint'
                )
              "
            >
              <el-input
                v-model="
                  model.uncontactable_anonymous_profiles_retention_period
                "
                placeholder="None"
              />
            </rest-form-item>
          </el-col>

          <el-col :span="8">
            <rest-form-item
              prop="uncontactable_identified_profiles_retention_period"
              :label="
                $t(
                  'DataRetention_Field_UncontactableIdentifiedProfilesRetentionPeriod'
                )
              "
              :hint="
                $t(
                  'DataRetention_Field_UncontactableIdentifiedProfilesRetentionPeriod_Hint'
                )
              "
            >
              <el-input
                v-model="
                  model.uncontactable_identified_profiles_retention_period
                "
                placeholder="None"
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>

      <form-section
        :title="$t('DataRetention_AuditLog_Title')"
        :description="$t('DataRetention_AuditLog_Description')"
      >
        <el-row>
          <el-col :span="12">
            <rest-form-item
              prop="profile_auditlog_retention_period_months"
              :label="$t('DataRetention_Field_ProfileAuditLog')"
              :hint="$t('DataRetention_Field_ProfileAuditLog_Hint')"
            >
              <el-input
                v-model="model.profile_auditlog_retention_period_months"
                :placeholder="
                  $t('DataRetention_Field_ProfileCampaign_Placeholder')
                "
              />
            </rest-form-item>
          </el-col>

          <el-col :span="12">
            <rest-form-item
              prop="campaign_auditlog_retention_period_months"
              :label="$t('DataRetention_Field_CampaignAuditLog')"
              :hint="$t('DataRetention_Field_CampaignAuditLog_Hint')"
            >
              <el-input
                v-model="model.campaign_auditlog_retention_period_months"
                :placeholder="
                  $t('DataRetention_Field_ProfileCampaign_Placeholder')
                "
              />
            </rest-form-item>
          </el-col>
        </el-row>
      </form-section>
    </template>
  </rest-form-page>
</template>

<script>
import RestFormPage from '@/common/components/rest/RestFormPage'
import RestFormItem from '@/common/components/rest/RestFormItem'
import FormSection from '@/common/components/form/FormSection'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'DataRetentionPage',

  components: {
    RestFormPage,
    RestFormItem,
    FormSection
  },

  data() {
    return {
      model: null
    }
  },

  computed: {
    pageTitle() {
      return this.$t(this.$route.meta.title)
    },

    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `retention-policy`,
        handler: data => {
          this.model = data
        }
      })
    },

    saveEndpoint() {
      return projectEndpoint({
        method: 'patch',
        url: `retention-policy`,
        params: {
          data: this.model
        }
      })
    },

    readonly() {
      return !this.$isRole('admin')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/settings/pages/DataRetentionPage.vue